import React from "react";

import { useThemeProps } from "../../../../../../wsui/base";

import PageModules from "./PageModules.jsx";

export default function PageContentAreaBottomModules(props) {
  props = useThemeProps({ props, name: "PageContentAreaBottomModules" });
  let { ...restProps } = props;
  return <PageModules area="contentAreaBottom" {...restProps} />;
}
